import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import axios from 'axios'
import { Snackbar, Alert } from '@mui/material'

const GAME_IMAGES = [
  '/gamepictures/truthbackground.webp',
  '/gamepictures/lightdarebackground.webp',
  '/gamepictures/darebackground.webp',
  '/gamepictures/truthcard.webp',
  '/gamepictures/lightdarecard.webp',
  '/gamepictures/darecard.webp',
  '/gamepictures/kinkydarecard.webp',
  '/gamepictures/backgroundphone.webp',
  '/gamepictures/backgroundsixteenonnine.webp',
  '/gamepictures/backgroundfouronthree.webp',
];

export default function Root () {
  const [rateLimited, setRateLimited] = useState(false)

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 429) {
          setRateLimited(true)
        }
        return Promise.reject(error)
      }
    )
    return () => axios.interceptors.response.eject(interceptor)
  }, [])

  useEffect(() => {
    GAME_IMAGES.forEach((src) => {
      const img = new Image();
      img.src = src;
    });

    const params = new URLSearchParams(window.location.search);
    const source = params.get('utm_source');
    const campaign = params.get('utm_campaign');
    if (source) sessionStorage.setItem('utm_source', source);
    if (campaign) sessionStorage.setItem('utm_campaign', campaign);
  }, []);

  return (
    <>
      <main className='flex-shrink-0'>
        <div className='container'>
          <Outlet />
        </div>
      </main>

      <Snackbar
        open={rateLimited}
        autoHideDuration={5000}
        onClose={() => setRateLimited(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity="warning" onClose={() => setRateLimited(false)} sx={{ width: '100%' }}>
          Too many requests. Please wait a moment before trying again.
        </Alert>
      </Snackbar>
    </>
  )
}
